// src/lib/formatters.js
import { format, formatDistanceToNow, parseISO } from 'date-fns';
import { getDateFnsLocale } from './locale';
import {
  CURRENCY_METADATA,
  DEFAULT_CURRENCY,
} from '../constants/currencies';
import useAuthStore from '../stores/authStore';

export function formatCurrency(amount, currency) {
  const code =
    currency || useAuthStore.getState().currency || DEFAULT_CURRENCY;
  const meta = CURRENCY_METADATA[code] || CURRENCY_METADATA[DEFAULT_CURRENCY];
  return `${Number(amount).toFixed(meta.decimals)} ${meta.symbol}`;
}

export function getCurrencySymbol(currency) {
  const code =
    currency || useAuthStore.getState().currency || DEFAULT_CURRENCY;
  return (CURRENCY_METADATA[code] || CURRENCY_METADATA[DEFAULT_CURRENCY])
    .symbol;
}

export function formatDate(dateString) {
  return format(parseISO(dateString), 'dd.MM.yyyy', { locale: getDateFnsLocale() });
}

export function formatTime(dateString) {
  return format(parseISO(dateString), 'HH:mm', { locale: getDateFnsLocale() });
}

export function formatDateTime(dateString) {
  return format(parseISO(dateString), 'dd.MM.yyyy HH:mm', { locale: getDateFnsLocale() });
}

export function formatRelativeTime(dateString) {
  return formatDistanceToNow(parseISO(dateString), {
    addSuffix: true,
    locale: getDateFnsLocale(),
  });
}

export function formatOrderNumber(orderNumber) {
  return `#${String(orderNumber).padStart(4, '0')}`;
}
